import { InvoiceEvent } from '@/domain/models/invoice/internal-company-manager/invoice-event-model'
import { Pagination } from '@/domain/models/pagination-model'
import { InvoiceEventSearch } from '@/domain/usecases/invoice/internal-company-manager/invoice-event-search'
import { queryClient } from '@/infra/http'
import { parseNumber } from '@/main/helpers/number-helper'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads invoice event list for internal company manager
 * Supports pagination and filtering by status groups
 */
export async function loadInvoiceList(request: Request) {
  const url = new URL(request.url)
  const params = createSearchParams(url.searchParams)
  const tab = parseStatusGroup(url.searchParams.get(InvoiceEventSearch.TAB_QUERY_PARAM_NAME))

  const remoteInvoiceEventSearch = await importRemote<InvoiceEventSearch>(
    'makeRemoteInvoiceEventSearch',
    queryClient
  )

  return {
    data: remoteInvoiceEventSearch.loader(params),
    remote: remoteInvoiceEventSearch,
    params,
    tab
  }
}

function createSearchParams(searchParams: URLSearchParams): InvoiceEventSearch.Params {
  const tab = searchParams.get(InvoiceEventSearch.TAB_QUERY_PARAM_NAME)
  const search = searchParams.get(InvoiceEventSearch.SEARCH_QUERY_PARAM_NAME)
  const page = searchParams.get(Pagination.PAGE_PARAM_NAME)
  const pageSize = searchParams.get(Pagination.PAGE_SIZE_PARAM_NAME)

  return {
    tab: tab ? parseStatusGroup(tab) : InvoiceEventSearch.TabListGroup.NOT_CLASSIFIED,
    search: search ?? '',
    statuses: parseStatus(tab),
    page: parseNumber(page, Pagination.DEFAULT_PAGE)!,
    pageSize: parseNumber(pageSize, InvoiceEventSearch.DEFAULT_PAGE_SIZE)
  }
}

function parseStatusGroup(tab: string | null): InvoiceEventSearch.TabListGroup {
  if (!tab) return InvoiceEventSearch.TabListGroup.NOT_CLASSIFIED

  return (
    Object.values(InvoiceEventSearch.TabListGroup).find(
      s => s.toLowerCase() === tab.toLowerCase()
    ) ?? InvoiceEventSearch.TabListGroup.NOT_CLASSIFIED
  )
}

function parseStatus(tab: string | null): InvoiceEvent.Status[] {
  return InvoiceEventSearch.parseInvoiceEventStatus(parseStatusGroup(tab))
}
